import Tooltip from 'tooltip.js';
import { node_observable_component } from 'common/util/ComponentDecorator';
import ModalUtil from "common/util/ModalUtil";
import observerUtil from 'common/util/ObserverUtil';

@node_observable_component
export default class ShareBtn {
	static classname = 'js-share-btn';

	constructor($btn) {
		this.$btn = $btn;
		this.bindEvents();
	}

	bindEvents() {
		const self = this;
		if (this.$btn.hasClass('js-share-btn--modal')) {
			this.$btn.on('click', function() {
				if (window.Ya === undefined || (window.Ya !== undefined && window.Ya.share2 === undefined)) {
					$.when(
						$.getScript("https://yastatic.net/share2/share.js"),
						$.Deferred(function (deferred) {
							$(deferred.resolve);
						})).done(function () {
						self.openModal();
					});
				} else {
					self.openModal();
				}
			});
		}

		if (this.$btn.hasClass('js-share-btn--tooltip')) {
			this.$btn.on('mouseover', function() {
				if (window.Ya === undefined || (window.Ya !== undefined && window.Ya.share2 === undefined)) {
					$.when(
						$.getScript("https://yastatic.net/share2/share.js"),
						$.Deferred(function (deferred) {
							$(deferred.resolve);
						})).done(function () {
							self.$btn.addClass('js-share-btn_inited');
							self.setTooltip('show');
					});
				} else if (!self.$btn.hasClass('js-share-btn_inited')) {
					self.setTooltip();
				}
			});
		}

		observerUtil.observeComponent('share__link_copy', ($link) => {
			$link.on('click', () => {
				const $linkText = $link.find('.share__link-text');
				const textLink = $link.text();

				navigator.clipboard.writeText(location.href).then(function () {
					$linkText.text('Ссылка скопирована');
					setTimeout(() => {
						$linkText.text(textLink)
					}, 5000);
				}).catch(function (e) {
					console.error(e)
				});
			})
		});
	}

	setTooltip(event) {
		var tooltip = new Tooltip(this.$btn, {
			html: true,
			title: $('.share')[0],
			placement: 'bottom',
			container: document.querySelector('body'),
			template: `<div class="tooltip tooltip--yashare"
											role="tooltip">
											<div class="tooltip-arrow"></div>
											<div class="tooltip-inner"></div>
								 </div>`
		});

		if (event === 'show') {
			tooltip.show();
		}
	}

	openModal() {
		ModalUtil.openContent($($('#modal-ya-share2-template').prop('content').cloneNode(true)));
	}

}


